import Vue from 'vue';
import { FormatWithPrecision } from '@/lib/services/Utils';

Vue.filter('formatDecimal', (value: number | null | any | string, precision: number = 0) => {
    return FormatWithPrecision(value, precision);
});

